export default __webpack_public_path__ + "static/media/cat2-1-2.505265c9.jpg";